[
  {
    "bpnl": "BPNL0001",
    "legalName": "Test Organisation0.8e060584",
    "shortName": "Test Org0.8e060584",
    "sector": "IT",
    "legalForm": "GmbH",
    "website": "http://www.0.8e060584.com",
    "description": "adesso SE ist ein führendes IT-Dienstleistungsunternehmen mit Schwerpunkt auf der digitalen Transformation. Das Unternehmen unterstützt Kunden bei der Konzeption, Entwicklung und Implementierung innovativer IT-Lösungen. adesso bietet branchenspezifische Beratung, Softwareentwicklung und Systemintegration, insbesondere in den Bereichen Finanzdienstleistungen, Versicherungen, Gesundheitswesen, öffentliche Verwaltung, Automobilindustrie und weitere Sektoren. Mit einem starken Fokus auf agile Methoden, moderne Technologien und individuelle Kundenbedürfnisse trägt adesso dazu bei, Geschäftsprozesse zu optimieren und digitale Innovationen voranzutreiben.",
    "foundingDate": "2025-11-28",
    "createdDate": "2025-12-01",
    "street": "Test Street",
    "houseNumber": "1",
    "postalCode": "12345",
    "city": "Test City",
    "country": "DE",
    "commercialRegisterNumber": "HRB559411",
    "commercialRegisterCourt": "München",
    "taxIdNumber": "DE12559411",
    "admissionState": "PENDING",
    "activityState": "INACTIVE",
    "representative": {
      "title": "Mr",
      "firstName": "John",
      "lastName": "Doe",
      "position": "CEO",
      "email": "0.8e060584@test.com",
      "phoneNumber": "+49 123 456 789",
      "roles": [
        "ORGANIZATION_REPRESENTATIVE"
      ]
    },
    "document": {
      "fileName": "registrationPreface.pdf",
      "contentType": "application/pdf",
      "data": "JVBERi0xLjQKMSAwIG9iago8PC9UeXBlIC9DYXRhbG9nCi9QYWdlcyAyIDAgUgo+PgplbmRvYmoKMiAwIG9iago8PC9UeXBlIC9QYWdlcwovS2lkcyBbMyAwIFJdCi9Db3VudCAxCj4+CmVuZG9iagozIDAgb2JqCjw8L1R5cGUgL1BhZ2UKL1BhcmVudCAyIDAgUgovTWVkaWFCb3ggWzAgMCA1OTUgODQyXQovQ29udGVudHMgNSAwIFIKL1Jlc291cmNlcyA8PC9Qcm9jU2V0IFsvUERGIC9UZXh0XQovRm9udCA8PC9GMSA0IDAgUj4+Cj4+Cj4+CmVuZG9iago0IDAgb2JqCjw8L1R5cGUgL0ZvbnQKL1N1YnR5cGUgL1R5cGUxCi9OYW1lIC9GMQovQmFzZUZvbnQgL0hlbHZldGljYQovRW5jb2RpbmcgL01hY1JvbWFuRW5jb2RpbmcKPj4KZW5kb2JqCjUgMCBvYmoKPDwvTGVuZ3RoIDUzCj4+CnN0cmVhbQpCVAovRjEgMjAgVGYKMjIwIDQwMCBUZAooRHVtbXkgUERGKSBUagpFVAplbmRzdHJlYW0KZW5kb2JqCnhyZWYKMCA2CjAwMDAwMDAwMDAgNjU1MzUgZgowMDAwMDAwMDA5IDAwMDAwIG4KMDAwMDAwMDA2MyAwMDAwMCBuCjAwMDAwMDAxMjQgMDAwMDAgbgowMDAwMDAwMjc3IDAwMDAwIG4KMDAwMDAwMDM5MiAwMDAwMCBuCnRyYWlsZXIKPDwvU2l6ZSA2Ci9Sb290IDEgMCBSCj4+CnN0YXJ0eHJlZgo0OTUKJSVFT0YK"
    },
    "id": "6fb7fc8e-1990-4209-9f6c-c302e64698c8",
    "did": "did:web:6fb7fc8e-1990-4209-9f6c-c302e64698c8.example.com"
  }
]